﻿import { Popup, PopupPosition } from "../../utilities/popup";

declare const UIkit: any;

export enum TooltipType
{
    Popup = "popup",
    Hover = "hover",
}

export enum TooltipTrigger
{
    Hover = "hover",
    Click = "click",
}

export class TooltipOptions
{
    class?: string;
    content?: string | null;
    trigger?: TooltipTrigger = TooltipTrigger.Hover;
    type?: TooltipType = TooltipType.Hover;
}

export class Tooltip
{
    constructor(element: string, options?: TooltipOptions | null)
    {
        $(element).each(function ()
        {
            let tooltipContent = "";
            const title = $(this).attr("title");
            const dataContent = $(this).data("tooltip-content");

            if (options?.content)
                tooltipContent = options.content;
            else if (title)
                tooltipContent = title;
            else if (dataContent)
            {
                if (dataContent.startsWith("#"))
                    tooltipContent = $(dataContent).html();
            }

            if (options?.trigger == TooltipTrigger.Click && options?.type == TooltipType.Hover)
            {
                UIkit.tooltip(this, { title: tooltipContent });

                this.addEventListener('mouseenter', e => e.stopImmediatePropagation());

                let open = false;

                this.addEventListener('click', () => {
                    if (!open) {
                        UIkit.util.trigger(this, 'mouseenter');
                        open = true;
                    } else {
                        UIkit.util.trigger(this, 'mouseleave');
                        open = false;
                    }
                });
            }
            else if (options?.trigger == TooltipTrigger.Click && options?.type == TooltipType.Popup)
            {
                this.addEventListener("click", () => openTooltipPopup(tooltipContent))
            }
            else
            {
                if (tooltipContent)
                    UIkit.tooltip(this, { title: tooltipContent });
            }
        });
    }
}

export const reInitTooltips = () =>
{
    new Tooltip(".tooltip");
}

// Init default tooltip
new Tooltip(".tooltip");

let tooltipPopup: Popup;

const openTooltipPopup = (content: string) =>
{
    if (!tooltipPopup)
        initTooltipPopup(content);

    if ($(content).text() !== tooltipPopup.getContent().textContent)
        tooltipPopup.updateContent(content);

    tooltipPopup.show();
}

const initTooltipPopup = (content: string) =>
{
    tooltipPopup = new Popup({
        id: "tooltip-popup",
        title: "Tooltip",
        content: content,
        desktopPosition: PopupPosition.Center,
        mobilePosition: PopupPosition.Center,
        closeButton: true,
    });
}
